import React, { useEffect, useState } from 'react';
import { useMenu } from '../utils/Menu'; // Import the hook, not the default
import { useBusinessContext } from '../../components/BusinessContext';
// import './Sidebar.css'; // Import CSS for styling

function Sidebar() {
  const { businessId, businessName, logo, loading } = useBusinessContext();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true); // State for sidebar visibility
  const menuItems = useMenu(); // This will update automatically when BC config changes

  // Debug logging
  useEffect(() => {
    console.log('Sidebar Context Values:', { businessId, businessName, logo, loading });
  }, [businessId, businessName, logo, loading]);

  // Debug menu items
  useEffect(() => {
    console.log('Menu items updated:', menuItems);
  }, [menuItems]);

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
    console.log('Sidebar toggled:', !isSidebarOpen);
  };

  // Navigate to previous page (-1 navigation)
  const navigateBack = () => {
    console.log('Navigating to previous page');
    window.history.back();
  };

  // Handle page refresh
  const handleRefresh = () => {
    console.log('Refreshing page');
    window.location.reload();
  };

  // Fallback values
  const displayName = loading ? 'Loading...' : businessName || '';
  const displayLogo = logo || null;

  return (
    <aside className={`sidebar sidebar-default sidebar-white sidebar-base navs-rounded-all ${isSidebarOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-header d-flex align-items-center justify-content-start">
        <a href="#/dashboard/informational" className="navbar-brand">
          <div className="logo-main">
            {loading ? (
              <div>Loading...</div>
            ) : displayLogo ? (
              <img
                src={displayLogo}
                alt={displayName}
                className="business-logo"
                style={{ width: '90px', height: '90px', borderRadius: '50%' }}
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/80?text=No+Logo';
                }}
              />
            ) : (
              <div className="logo-normal">
                <svg
                  className="icon-30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="-0.757324"
                    y="19.2427"
                    width="28"
                    height="4"
                    rx="2"
                    transform="rotate(-45 -0.757324 19.2427)"
                    fill="currentColor"
                  />
                  <rect
                    x="7.72803"
                    y="27.728"
                    width="28"
                    height="4"
                    rx="2"
                    transform="rotate(-45 7.72803 27.728)"
                    fill="currentColor"
                  />
                  <rect
                    x="10.5366"
                    y="16.3945"
                    width="16"
                    height="4"
                    rx="2"
                    transform="rotate(45 10.5366 16.3945)"
                    fill="currentColor"
                  />
                  <rect
                    x="10.5562"
                    y="-0.556152"
                    width="28"
                    height="4"
                    rx="2"
                    transform="rotate(45 10.5562 -0.556152)"
                    fill="currentColor"
                  />
                </svg>
              </div>
            )}
          </div>
          {/* <h6 className="logo-title">{displayName}</h6> */}
        </a>
        {/* Toggle sidebar visibility */}
        <div className="sidebar-toggle" data-toggle="sidebar" data-active={isSidebarOpen} onClick={toggleSidebar}>
          <i className="icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.25 12.2744L19.25 12.2744"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </i>
        </div>
        {/* Navigate to previous page (-1 navigation) */}
        <div className="sidebar-toggle" data-toggle="global-nav" onClick={navigateBack}>
          <i className="icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z"
                fill="currentColor"
              />
            </svg>
          </i>
        </div>
      </div>
      {/* Main sidebar navigation */}
      <nav
        className="sidebar-body pt-0 data-scrollbar"
        style={{ overflow: isSidebarOpen ? 'scroll' : 'hidden', outline: 'none', display: isSidebarOpen ? 'block' : 'none' }}
      >
        <div className="sidebar-list">
          <ul className="navbar-nav iq-main-menu" id="sidebar-menu">
            <li className="nav-item static-item">
              <a
                className="nav-link static-item disabled"
                href="#"
                tabIndex="-1"
              >
                {/* <span className="default-icon">Home</span> */}
                <span className="mini-icon">-</span>
              </a>
            </li>

            {menuItems.map((menu, idx) => (
              <li key={`sidebar_${menu.code}_${idx}`} className="nav-item">
                {menu?.submenu?.length > 0 ? (
                  <>
                    <a
                      className={`nav-link dropdown-indicator ${idx === 0 ? 'active' : ''}`}
                      href={`#${menu.path}`}
                      role="button"
                      data-bs-toggle="collapse"
                      aria-expanded="false"
                      aria-controls={`${menu.path}`}
                    >
                      <i className="icon">
                        {menu.icon || (
                          <svg
                            className="icon-20"
                            width="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              opacity="0.4"
                              d="M13.3051 5.88243V6.06547C12.8144 6.05584 12.3237 6.05584 11.8331 6.05584V5.89206C11.8331 5.22733 11.2737 4.68784 10.6064 4.68784H9.63482C8.52589 4.68784 7.62305 3.80152 7.62305 2.72254C7.62305 2.32755 7.95671 2 8.35906 2C8.77123 2 9.09508 2.32755 9.09508 2.72254C9.09508 3.01155 9.34042 3.24276 9.63482 3.24276H10.6064C12.0882 3.2524 13.2953 4.43736 13.3051 5.88243Z"
                              fill="currentColor"
                            ></path>
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M15.164 6.08279C15.4791 6.08712 15.7949 6.09145 16.1119 6.09469C19.5172 6.09469 22 8.52241 22 11.875V16.1813C22 19.5339 19.5172 21.9616 16.1119 21.9616C14.7478 21.9905 13.3837 22.0001 12.0098 22.0001C10.6359 22.0001 9.25221 21.9905 7.88813 21.9616C4.48283 21.9616 2 19.5339 2 16.1813V11.875C2 8.52241 4.48283 6.09469 7.89794 6.09469C9.18351 6.07542 10.4985 6.05615 11.8332 6.05615C12.3238 6.05615 12.8145 6.05615 13.3052 6.06579C13.9238 6.06579 14.5425 6.07427 15.164 6.08279ZM10.8518 14.7459H9.82139V15.767C9.82139 16.162 9.48773 16.4896 9.08538 16.4896C8.67321 16.4896 8.34936 16.162 8.34936 15.767V14.7459H7.30913C6.90677 14.7459 6.57311 14.4279 6.57311 14.0233C6.57311 13.6283 6.90677 13.3008 7.30913 13.3008H8.34936V12.2892C8.34936 11.8942 8.67321 11.5667 9.08538 11.5667C9.48773 11.5667 9.82139 11.8942 9.82139 12.2892V13.3008H10.8518C11.2542 13.3008 11.5878 13.6283 11.5878 14.0233C11.5878 14.4279 11.2542 14.7459 10.8518 14.7459ZM15.0226 13.1177H15.1207C15.5231 13.1177 15.8567 12.7998 15.8567 12.3952C15.8567 12.0002 15.5231 11.6727 15.1207 11.6727H15.0226C14.6104 11.6727 14.2866 12.0002 14.2866 12.3952C14.2866 12.7998 14.6104 13.1177 15.0226 13.1177ZM16.7007 16.4318H16.7988C17.2012 16.4318 17.5348 16.1139 17.5348 15.7092C17.5348 15.3143 17.2012 14.9867 16.7988 14.9867H16.7007C16.2885 14.9867 15.9647 15.3143 15.9647 15.7092C15.9647 16.1139 16.2885 16.4318 16.7007 16.4318Z"
                              fill="currentColor"
                            ></path>
                          </svg>
                        )}
                      </i>
                      <span className="item-name">{menu.title}</span>
                      <i className="right-icon">
                        <svg
                          className="icon-18"
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 5l7 7-7 7"
                          />
                        </svg>
                      </i>
                    </a>
                    <ul
                      id={`${menu.path}`}
                      className="sub-nav collapse"
                      data-bs-parent="#sidebar-menu"
                    >
                      {menu.submenu.map((submenu, sidx) => (
                        <li key={`submenu_${menu.code}_${sidx}`} className="nav-item">
                          <a className="nav-link" href={`#${submenu.path}`}>
                            <div className="d-flex align-items-center">
                              <span className="nav-link-text ps-1">{`${submenu.title}`}</span>
                            </div>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <a
                    className={`nav-link ${idx === 0 ? 'active' : ''}`}
                    href={`#${menu.path}`}
                  >
                    <i className="icon">
                      {menu.icon || (
                        <svg
                          className="icon-20"
                          width="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M7.7688 8.71387H16.2312C18.5886 8.71387 20.5 10.5831 20.5 12.8885V17.8254C20.5 20.1308 18.5886 22 16.2312 22H7.7688C5.41136 22 3.5 20.1308 3.5 17.8254V12.8885C3.5 10.5831 5.41136 8.71387 7.7688 8.71387ZM11.9949 17.3295C12.4928 17.3295 12.8891 16.9419 12.8891 16.455V14.2489C12.8891 13.772 12.4928 13.3844 11.9949 13.3844C11.5072 13.3844 11.1109 13.772 11.1109 14.2489V16.455C11.1109 16.9419 11.5072 17.3295 11.9949 17.3295Z"
                            fill="currentColor"
                          ></path>
                          <path
                            opacity="0.4"
                            d="M17.523 7.39595V8.86667C17.1673 8.7673 16.7913 8.71761 16.4052 8.71761H15.7447V7.39595C15.7447 5.37868 14.0681 3.73903 12.0053 3.73903C9.94257 3.73903 8.26594 5.36874 8.25578 7.37608V8.71761H7.60545C7.20916 8.71761 6.83319 8.7673 6.47754 8.87661V7.39595C6.4877 4.41476 8.95692 2 11.985 2C15.0537 2 17.523 4.41476 17.523 7.39595Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      )}
                    </i>
                    <span className="item-name">{menu.title}</span>
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>
      </nav>
      <div className="sidebar-footer"></div>
    </aside>
  );
}

export default Sidebar;